import {
    Add,
    Attachment,
    Check,
    Circle,
    Close,
    Delete,
    Edit,
    ExpandMore,
    FileDownloadOutlined,
    PersonAddAlt1,
    PictureAsPdf,
    Search,
    Upload,
    Visibility,
} from '@mui/icons-material';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Autocomplete,
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    InputAdornment,
    LinearProgress,
    List,
    ListItemButton,
    ListItemText,
    MenuItem,
    Paper,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableBody,
    TextField,
    Typography,
    Zoom,
} from '@mui/material';
import {
    DataGridPro,
    GridToolbarContainer,
    GridToolbarQuickFilter,
    itIT,
} from '@mui/x-data-grid-pro';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useCallback, useRef } from 'react';
import unsplash from '../api/unsplash';
import '../style/style.css';
import { CustomFooterPersonalized } from '../utils/CustomFooterPersonalized';
import GlobalSnackbar from './Snackbar';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

const CorsiCliente = (props) => {
    const [corsiCliente, setCorsiCliente] = useState([]);
    const [categorieCliente, setCategorieCliente] = useState([]);
    const [loading, setLoading] = useState(true);
    const [corsiClienteExport, setCorsiClienteExport] = useState([]);
    const [corsi, setCorsi] = useState([]);
    const [vistaCorsi, setVistaCorsi] = useState();
    const [openSnack, setOpenSnack] = useState(false);
    const [storicoFatturazioneCorsi, setStoricoFatturazioneCorsi] = useState(
        []
    );
    const [storicoFatturazioneCorsiBackup, setStoricoFatturazioneCorsiBackup] =
        useState([]);
    const value = 0;
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [corsiDaFatturare, setCorsiDaFatturare] = useState([]);
    const [openAlert, setOpenAlert] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);
    const [loadingStorico, setLoadingStorico] = useState(false);
    const visibilitaLimitata =
        String(sessionStorage.getItem('VisibilitaLimitata')) === '1';

    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    });
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };

    const toggleAlert = async (reload) => {
        if (reload) {
            setOpenAlert(!openAlert);
            let responsecorsiCliente = await unsplash.get(
                'corsiCliente',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                    params: { cliente: props.idAzienda },
                } //props.idAzienda}}
            );

            setCorsiCliente(responsecorsiCliente.data.data);
        } else {
            setOpenAlert(!openAlert);
        }
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <GridToolbarQuickFilter placeholder="Cerca..." />
                </Grid>
            </GridToolbarContainer>
        );
    }

    const columns = [
        {
            filterable: false,
            field: 'Actions',
            headerName: 'Azioni',
            hide: false,
            width: '130',
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <>
                    <FormDialog
                        id="edit"
                        operazione="Modifica"
                        corsi={corsiCliente}
                        categorie={categorieCliente}
                        reloadData={loadData}
                        saveFunction={handleSaveData}
                        corsoSel={params.row}
                    />
                    <AssociationDialog
                        id="edit"
                        idAzienda={props.idAzienda}
                        operazione="Modifica"
                        corsiCliente={corsiCliente}
                        corsi={corsiCliente}
                        reloadData={loadData}
                        handleShowSnack={handleShowSnack}
                        corsoSel={params.row}
                    />
                    <IconButton
                        aria-label="delete"
                        onClick={async () => {
                            await setVistaCorsi(params.row);
                            await toggleAlert();
                        }}
                    >
                        <Delete
                            style={{
                                height: '2rem',
                                width: '2rem',
                                color: '#FF2768',
                            }}
                        />
                    </IconButton>
                </>
            ),
        },
        {
            field: 'Codice',
            headerName: 'Codice',
            //width: 400,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Descrizione',
            headerName: 'Descrizione',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Importo',
            headerName: 'Importo',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'ImportoAggiornamento',
            headerName: 'Aggiornamento',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'ImportoEL',
            headerName: 'Importo E-Learning',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'ImportoAggiornamentoEL',
            headerName: 'Aggiornamento E-Learning',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'NomeCategoria',
            headerName: 'Nome Categoria',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'TipoCategoria',
            headerName: 'Tipo Categoria',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'CodiceCategoria',
            headerName: 'Codice Categoria',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
    ];

    const loadData = useCallback(async () => {
        const responseCorsiCliente = await unsplash.get('corsiCliente', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
            params: { cliente: props.idAzienda },
        });
        const responseCategorieCliente = await unsplash.get(
            `categorieCorsi/${props.idAzienda}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
            }
        );
        setCorsiCliente(responseCorsiCliente.data.data);
        setCategorieCliente(responseCategorieCliente.data.data);
        setLoading(false);
    }, [props.idAzienda]);

    const loadCorsiClienteExport = async () => {
        const responsecorsiClienteExport = await unsplash.get('corsiCliente', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
            params: { cliente: props.idAzienda, export: true },
        });
        const exportData = responsecorsiClienteExport.data.data || [];
        setCorsiClienteExport(exportData);
        return exportData;
    };

    const loadStoricoFatturazioneCorsi = useCallback(async () => {
        try {
            setLoadingStorico(true);
            const responseFatturazione = await unsplash.get(
                'storicoFatturazioneCorsi',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                    params: { cliente: props.idAzienda },
                }
            );
            setStoricoFatturazioneCorsi(responseFatturazione.data.data);
            setStoricoFatturazioneCorsiBackup(responseFatturazione.data.data);
        } catch (error) {
            console.error('Error loading storico fatturazione:', error);
        } finally {
            setLoadingStorico(false);
        }
    }, [props.idAzienda]);

    useEffect(() => {
        async function fetchData() {
            await loadData();

            // Load corsi data (needed for the form dialog)
            let responsecorsi = await unsplash.get('anagraficaCorsi', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                params: visibilitaLimitata ? { getAll: true } : undefined,
            });

            setCorsi(responsecorsi.data.data);
        }

        fetchData();
    }, [loadData, visibilitaLimitata]);

    // Load storico fatturazione when tab is clicked
    useEffect(() => {
        if (value === 1 && storicoFatturazioneCorsi.length === 0) {
            loadStoricoFatturazioneCorsi();
        }
    }, [value, storicoFatturazioneCorsi.length, loadStoricoFatturazioneCorsi]);

    const handleShowSnack = (text, severity) => {
        setSnack({
            severity: severity,
            messaggio: text,
        });
        setOpenSnack(true);
    };

    const handleSaveData = async (corso, importi, operazione, categoria) => {
        try {
            //inserisco il nuovo
            try {
                let dettaglioCorso = {
                    ID: corso.ID,
                    Corso: corso.Codice,
                    categoria: categoria.id,
                    Importo: importi.Importo,
                    ImportoAggiornamento: importi.ImportoAggiornamento,
                    ImportoEL: importi.ImportoEL,
                    ImportoAggiornamentoEL: importi.ImportoAggiornamentoEL,
                    ScadenzaPersonalizzata: importi.ScadenzaPersonalizzata,
                };

                if (operazione === 'Inserimento') {
                    await unsplash.post(
                        'corsiCliente',
                        { cliente: props.idAzienda, corso: dettaglioCorso },
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                            },
                        }
                    );
                } else {
                    await unsplash.put(
                        'corsiCliente',
                        { cliente: props.idAzienda, corso: dettaglioCorso },
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                            },
                        }
                    );
                }

                let responsecorsiCliente = await unsplash.get(
                    'corsiCliente',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                        params: { cliente: props.idAzienda },
                    } //props.idAzienda}}
                );

                setCorsiCliente(responsecorsiCliente.data.data);
                setSnack({
                    severity: 'success',
                    messaggio:
                        operazione === 'Inserimento'
                            ? 'Corso inserito con successo'
                            : 'Corso Modificato con successo',
                });
                setOpenSnack(true);
            } catch {
                setSnack({
                    severity: 'error',
                    messaggio: "Errore durante l'inserimento",
                });
                setOpenSnack(true);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleListItemClick = async (event, index) => {
        setSelectedIndex(index);
        let corsoSelezionato = storicoFatturazioneCorsi[index];

        let response = await unsplash.get('storicoFatturazioneCorsi', {
            params: {
                ID: corsoSelezionato.ID,
                cliente: props.idAzienda,
            },
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
        });
        calcoloPrefatturazione(response.data.data);
    };

    const calcoloPrefatturazione = (costiCorsi) => {
        //funzione per calcolare tutti i totali

        let totale = 0;

        for (let i = 0; i < costiCorsi.length; i++) {
            let totaleCorsoTipo = 0;

            for (let j = 0; j < costiCorsi[i].corsi.length; j++) {
                let totaleCorsoSelezionato = 0;
                let mostraInStampa = 0;
                if (costiCorsi[i].corsi[j].ModalitaFatturazione === 1) {
                    //tariffa a lavoratore

                    for (
                        let k = 0;
                        k < costiCorsi[i].corsi[j].Presenti.length;
                        k++
                    ) {
                        if (
                            costiCorsi[i].corsi[j].Presenti[k].EraPresente === 1
                        ) {
                            totaleCorsoSelezionato +=
                                costiCorsi[i].corsi[j].Tariffa;
                            mostraInStampa = 1;
                        }
                    }
                } else {
                    // FORFAIT
                    mostraInStampa = 1;
                    totaleCorsoSelezionato +=
                        costiCorsi[i].corsi[j].OreTotaliCorso *
                        costiCorsi[i].corsi[j].CostoForfait;
                }

                costiCorsi[i].corsi[j].totaleCorso = totaleCorsoSelezionato;
                totaleCorsoTipo += totaleCorsoSelezionato;
                costiCorsi[i].corsi[j].MostraInStampa = mostraInStampa;
            } //chiudo il singolo

            costiCorsi[i].totaleTipoCorso = totaleCorsoTipo;
            totale += totaleCorsoTipo;
        }
        costiCorsi.Totale = totale;
        setCorsiDaFatturare(costiCorsi);
    };

    const stampaReport = () => {
        const unit = 'pt';
        const size = 'A4'; // Use A1, A2, A3 or A4
        const orientation = 'portrait'; // portrait or landscape

        const doc = new jsPDF(orientation, unit, size);
        var img = new Image();
        img.src = require('../assets/images/Logo-ASTM.png');

        doc.setFillColor(34, 100, 174);
        doc.rect(0, 0, doc.internal.pageSize.getWidth(), 90, 'F');

        doc.addImage(img, 'PNG', 10, 10, 220, 70);
        doc.setTextColor(255, 255, 255);

        doc.setFont(undefined, 'bold');
        doc.setFontSize(13);
        doc.text(
            'FATTURAZIONE CORSI : ' +
                storicoFatturazioneCorsi[selectedIndex].PeriodoFatturazione +
                ' ' +
                storicoFatturazioneCorsi[selectedIndex].AnnoFatturazione,
            255,
            30
        );
        doc.text(
            doc.splitTextToSize(
                'CLIENTE : ' + props.RagioneSociale,
                doc.internal.pageSize.getWidth() - 255
            ),
            255,
            50
        );
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(13);
        doc.text('ELENCO CORSI ', 250, 120);

        for (let i = 0; i < corsiDaFatturare.length; i++) {
            let finalY = 120;

            if (doc.lastAutoTable.finalY) {
                finalY = doc.lastAutoTable.finalY;
            }

            doc.autoTable({
                useCss: true,
                startY: 20 + finalY,
                html: '#mytable' + i,
                headStyles: { fillColor: [124, 95, 240] },
            });
        }

        let finalY = 120;

        if (doc.lastAutoTable.finalY) {
            finalY = doc.lastAutoTable.finalY;
        }

        doc.autoTable({
            useCss: true,
            startY: 20 + finalY,
            html: '#footerTable',
            headStyles: { fillColor: [124, 95, 240] },
        });

        doc.output('pdfobjectnewwindow', 'prefatturazione');
    };

    const handleAnnullaStampa = async () => {
        try {
            await unsplash.put(
                'storicoFatturazioneCorsi',
                {
                    cliente: props.idAzienda,
                    ID: storicoFatturazioneCorsi[selectedIndex].ID,
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );

            setCorsiDaFatturare([]);

            let responseFatturazione = await unsplash.get(
                'storicoFatturazioneCorsi',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                    params: { cliente: props.idAzienda },
                } //props.idAzienda}}
            );

            setStoricoFatturazioneCorsi(responseFatturazione.data.data);
            setStoricoFatturazioneCorsiBackup(responseFatturazione.data.data);
            setSelectedIndex(null);

            setSnack({
                severity: 'success',
                messaggio: 'Fatturazione annullata con successo',
            });
            setOpenSnack(true);
        } catch {
            setSnack({
                severity: 'error',
                messaggio: "Errore durante l'annullamento ",
            });
            setOpenSnack(true);
        }
    };

    const downloadStorico = async () => {
        setLoadingExport(true);
        try {
            const exportData =
                corsiClienteExport.length > 0
                    ? corsiClienteExport
                    : await loadCorsiClienteExport();

            if (exportData.length === 0) {
                handleShowSnack(
                    'Nessun dato disponibile per lo scadenzario',
                    'info'
                );
                return;
            }

            const workbook = new ExcelJS.Workbook();
            workbook.creator = 'Koala';
            workbook.created = new Date();
            const worksheet = workbook.addWorksheet('Scadenzario', {
                views: [{ state: 'frozen', ySplit: 6, xSplit: 4 }],
                pageSetup: {
                    orientation: 'landscape',
                    fitToPage: true,
                    fitToWidth: 1,
                    fitToHeight: 0,
                },
            });
            const fields = Object.keys(exportData[0]);
            const totalColumns = fields.length;
            const titleRange = `A1:${
                worksheet.getColumn(totalColumns).letter
            }1`;

            worksheet.mergeCells(titleRange);
            const titleCell = worksheet.getCell('A1');
            titleCell.value = 'SCADENZARIO FORMAZIONE';
            titleCell.font = {
                name: 'Arial',
                size: 18,
                bold: true,
                color: { argb: 'FFFFFFFF' },
            };
            titleCell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF11526F' },
            };
            titleCell.alignment = {
                vertical: 'middle',
                horizontal: 'left',
            };
            worksheet.getRow(1).height = 34;

            worksheet.mergeCells(
                `A2:${worksheet.getColumn(totalColumns).letter}2`
            );
            worksheet.getCell('A2').value = props.RagioneSociale;
            worksheet.getCell('A2').font = {
                name: 'Arial',
                size: 13,
                bold: true,
                color: { argb: 'FF263238' },
            };
            worksheet.getRow(2).height = 24;

            worksheet.mergeCells(
                `A3:${worksheet.getColumn(totalColumns).letter}3`
            );
            worksheet.getCell('A3').value = `Generato il ${moment().format(
                'DD/MM/YYYY [alle] HH:mm'
            )}`;
            worksheet.getCell('A3').font = {
                name: 'Arial',
                size: 10,
                color: { argb: 'FF607D8B' },
            };

            const legend = [
                ['Valido', 'FFC6EFCE'],
                ['In scadenza entro 90 giorni', 'FFFFE699'],
                ['Scaduto o mancante', 'FFF4CCCC'],
            ];
            legend.forEach(([label, color], index) => {
                const cell = worksheet.getCell(4, index * 2 + 1);
                cell.value = label;
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: color },
                };
                cell.font = { name: 'Arial', size: 9, bold: true };
                cell.alignment = { horizontal: 'center' };
            });

            const headerRowNumber = 6;
            const headerRow = worksheet.getRow(headerRowNumber);
            headerRow.values = fields;
            headerRow.height = 30;
            headerRow.eachCell((cell) => {
                cell.font = {
                    name: 'Arial',
                    size: 10,
                    bold: true,
                    color: { argb: 'FFFFFFFF' },
                };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF17627F' },
                };
                cell.alignment = {
                    vertical: 'middle',
                    horizontal: 'center',
                    wrapText: true,
                };
            });

            const statusColors = {
                green: 'FFC6EFCE',
                orange: 'FFFFE699',
                red: 'FFF4CCCC',
                gray: 'FFE7ECEF',
            };

            exportData.forEach((record) => {
                const row = worksheet.addRow(
                    fields.map((field) => {
                        const value = record[field];
                        if (
                            ['Nome', 'Cognome', 'Mansione', 'Sede'].includes(
                                field
                            )
                        ) {
                            return value || '';
                        }
                        return value?.Data ? new Date(value.Data) : null;
                    })
                );
                row.height = 24;
                fields.forEach((field, index) => {
                    const cell = row.getCell(index + 1);
                    const source = record[field];
                    cell.font = { name: 'Arial', size: 10 };
                    cell.alignment = {
                        vertical: 'middle',
                        horizontal: index < 4 ? 'left' : 'center',
                    };
                    cell.border = {
                        bottom: {
                            style: 'thin',
                            color: { argb: 'FFDCE5E9' },
                        },
                    };

                    if (index >= 4) {
                        cell.numFmt = 'dd/mm/yyyy';
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {
                                argb:
                                    statusColors[source?.ColoreScadenza] ||
                                    statusColors.gray,
                            },
                        };
                        if (source?.Scadenza) {
                            cell.note = `Scadenza: ${moment(
                                source.Scadenza
                            ).format('DD/MM/YYYY')}`;
                        }
                    }
                });
            });

            fields.forEach((field, index) => {
                const column = worksheet.getColumn(index + 1);
                column.width =
                    index < 2
                        ? 18
                        : index < 4
                          ? 24
                          : Math.max(14, Math.min(24, field.length + 3));
            });
            worksheet.autoFilter = {
                from: { row: headerRowNumber, column: 1 },
                to: { row: headerRowNumber, column: totalColumns },
            };

            const buffer = await workbook.xlsx.writeBuffer();
            const safeCompanyName = String(props.RagioneSociale || 'azienda')
                .replace(/[\\/:*?"<>|]/g, '')
                .replace(/\s+/g, '_');
            saveAs(
                new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                }),
                `Scadenzario_${safeCompanyName}_${moment().format(
                    'YYYY-MM-DD'
                )}.xlsx`
            );
        } catch (error) {
            console.error('Error exporting scadenzario:', error);
            handleShowSnack(
                'Errore durante la creazione dello scadenzario',
                'error'
            );
        } finally {
            setLoadingExport(false);
        }
    };

    const handleSearch = (e) => {
        // filtro

        setSelectedIndex(null);
        //setAccertamentiStorico([]);
        if (e.target.value === '') {
            setStoricoFatturazioneCorsi(storicoFatturazioneCorsiBackup);
        } else {
            var storicoX = []; // popolo l'array
            var i;
            for (i = 0; i < storicoFatturazioneCorsiBackup.length; i++) {
                if (
                    storicoFatturazioneCorsiBackup[
                        i
                    ].PeriodoFatturazione.toLowerCase().includes(
                        e.target.value.toLowerCase()
                    ) ||
                    storicoFatturazioneCorsiBackup[
                        i
                    ].AnnoFatturazione.toLowerCase().includes(
                        e.target.value.toLowerCase()
                    )
                ) {
                    storicoX.push(storicoFatturazioneCorsiBackup[i]);
                }
            }
            setStoricoFatturazioneCorsi(storicoX);
        }
    };

    return (
        <div>
            <GlobalSnackbar
                severity={snack.severity}
                messaggio={snack.messaggio}
                openSnack={openSnack}
                handleCloseSnack={handleCloseSnack}
            />
            <Box sx={{ width: '100%' }}>
                <TabPanel value={value} index={0}>
                    <Grid
                        container
                        direction="row"
                        spacing={2}
                        alignItems="center"
                        justifyContent="flex-end"
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                gap: 1,
                                flexWrap: 'wrap',
                                mb: 1,
                            }}
                        >
                            <Button
                                className="ButtonMiller"
                                startIcon={<Add />}
                                onClick={() =>
                                    document.getElementById('add').click()
                                }
                            >
                                AGGIUNGI
                            </Button>
                            <Button
                                startIcon={
                                    loadingExport ? (
                                        <CircularProgress
                                            color="inherit"
                                            size={20}
                                        />
                                    ) : (
                                        <FileDownloadOutlined />
                                    )
                                }
                                onClick={downloadStorico}
                                disabled={loadingExport}
                                variant="outlined"
                                sx={{ fontWeight: 600 }}
                            >
                                {loadingExport
                                    ? 'Preparazione file...'
                                    : 'Esporta scadenzario'}
                            </Button>
                        </Box>
                    </Grid>
                    <FormDialog
                        id="add"
                        operazione="Inserimento"
                        reloadData={loadData}
                        corsiCliente={corsiCliente}
                        corsi={corsi?.filter(
                            (corso) =>
                                !corsiCliente?.some(
                                    (c) => c.Corso === corso.Codice
                                )
                        )}
                        categorie={categorieCliente}
                        saveFunction={handleSaveData}
                    />

                    <DeleteCorsi
                        corso={vistaCorsi}
                        openValue={openAlert}
                        openFunction={toggleAlert}
                    />
                    <Box
                        sx={{
                            height: 'max(360px, calc(100dvh - 380px))',
                            width: '100%',
                        }}
                    >
                        <DataGridPro
                            localeText={
                                itIT.components.MuiDataGrid.defaultProps
                                    .localeText
                            }
                            components={{
                                Toolbar: CustomToolbar,
                                Footer: CustomFooterPersonalized,
                            }}
                            slots={{
                                loadingOverlay: LinearProgress,
                            }}
                            loading={loading}
                            initialState={{
                                pinnedColumns: { left: ['Actions'] },
                            }}
                            rows={corsiCliente}
                            getRowId={(corsiCliente) => corsiCliente.ID}
                            columns={columns}
                        />
                    </Box>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    {loadingStorico ? (
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            minHeight="200px"
                        >
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Grid container spacing={2}>
                            <Grid item xs={3}>
                                <TextField
                                    sx={{
                                        '& legend': { display: 'none' },
                                        '& fieldset': { top: 0 },
                                    }}
                                    size="small"
                                    fullWidth
                                    id="input-with-icon-textfield"
                                    onChange={handleSearch}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search />
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                />
                                {storicoFatturazioneCorsi.length <= 0 ? (
                                    <>
                                        <br /> <br />
                                        Nessuna prefatturazione presente
                                    </>
                                ) : (
                                    ''
                                )}
                                <Box
                                    sx={{
                                        width: '100%',
                                        maxWidth: 360,
                                        bgcolor: 'background.paper',
                                    }}
                                >
                                    <List
                                        component="nav"
                                        aria-label="main mailbox folders"
                                        sx={{
                                            width: '100%',
                                            maxWidth: 360,
                                            bgcolor: 'background.paper',
                                            position: 'relative',
                                            overflow: 'auto',
                                            direction: 'rtl',
                                            maxHeight: '55vh',
                                            marginTop: 1,
                                            padding: 0,
                                            borderRadius: '4px',
                                            '& ul': { padding: 0 },
                                        }}
                                    >
                                        {storicoFatturazioneCorsi.map(
                                            (t, index) => {
                                                return (
                                                    <ListItemButton
                                                        selected={
                                                            selectedIndex ===
                                                            index
                                                        }
                                                        onClick={(event) =>
                                                            handleListItemClick(
                                                                event,
                                                                index
                                                            )
                                                        }
                                                        sx={{
                                                            background:
                                                                '#2265B1',
                                                            color: 'white',
                                                            '&:hover': {
                                                                backgroundColor:
                                                                    '#11526F',
                                                            },
                                                            '&$selected': {
                                                                backgroundColor:
                                                                    '#FF2768!important',
                                                            },
                                                        }}
                                                        classes={{
                                                            selected:
                                                                'selectedList',
                                                        }}
                                                    >
                                                        <ListItemText
                                                            primary={
                                                                t.PeriodoFatturazione +
                                                                ' ' +
                                                                t.AnnoFatturazione
                                                            }
                                                        />
                                                    </ListItemButton>
                                                );
                                            }
                                        )}
                                    </List>
                                </Box>
                            </Grid>

                            <Grid item xs={9}>
                                {corsiDaFatturare.length > 0 ? (
                                    <>
                                        <div className="mt-2 mb-4">
                                            TOTALE :{' '}
                                            <b>{corsiDaFatturare.Totale}€</b>
                                        </div>

                                        <Button
                                            startIcon={<PictureAsPdf />}
                                            size="small"
                                            onClick={stampaReport}
                                            className="ButtonMiller"
                                            variant="contained"
                                            sx={{ marginRight: '10px' }}
                                        >
                                            Stampa Fattura
                                        </Button>
                                        <Button
                                            startIcon={<Close />}
                                            size="small"
                                            onClick={handleAnnullaStampa}
                                            color="error"
                                            variant="contained"
                                        >
                                            Annulla Stampa
                                        </Button>
                                    </>
                                ) : (
                                    ''
                                )}
                                <div className="my-2">
                                    {corsiDaFatturare?.map(
                                        (tipoCorso, indexTipoCorso) => (
                                            <Accordion>
                                                <AccordionSummary
                                                    expandIcon={
                                                        <ExpandMore
                                                            sx={{
                                                                color: 'white',
                                                            }}
                                                        />
                                                    }
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                    className="AccordionMiller"
                                                >
                                                    <Typography>
                                                        {tipoCorso.DescrizioneCorso +
                                                            ' - TOTALE ' +
                                                            tipoCorso.totaleTipoCorso +
                                                            ' €'}{' '}
                                                    </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    {tipoCorso.corsi.map(
                                                        (
                                                            corso,
                                                            indexCorsoSpecifico
                                                        ) => (
                                                            <Accordion>
                                                                <AccordionSummary
                                                                    expandIcon={
                                                                        <ExpandMore
                                                                            sx={{
                                                                                color: 'white',
                                                                            }}
                                                                        />
                                                                    }
                                                                    aria-controls="panel1a-content"
                                                                    id="panel1a-header"
                                                                    className="AccordionMiller"
                                                                >
                                                                    <Typography>
                                                                        {'Inizio : ' +
                                                                            moment(
                                                                                corso.DataInizio
                                                                            ).format(
                                                                                'DD/MM/YYYY'
                                                                            ) +
                                                                            ' - Fine : ' +
                                                                            moment(
                                                                                corso.DataFine
                                                                            ).format(
                                                                                'DD/MM/YYYY'
                                                                            ) +
                                                                            '  - Durata : ' +
                                                                            corso.OreTotaliCorso +
                                                                            ' h - ' +
                                                                            corso.ModalitaDescrizione +
                                                                            ' - ' +
                                                                            (corso.DescrizioneFatturazione
                                                                                ? corso.DescrizioneFatturazione
                                                                                : 'Tariffa a Lavoratore') +
                                                                            ' - '}
                                                                    </Typography>
                                                                    <Typography>
                                                                        {'Tariffa : ' +
                                                                            (corso.ModalitaFatturazione ===
                                                                            1
                                                                                ? corso.Tariffa +
                                                                                  ' €'
                                                                                : corso.CostoForfait +
                                                                                  ' €') +
                                                                            (corso.Aggiornamento ===
                                                                            1
                                                                                ? ' - Aggiornamento'
                                                                                : '') +
                                                                            ' - TOTALE : ' +
                                                                            corso.totaleCorso +
                                                                            ' €'}
                                                                    </Typography>
                                                                </AccordionSummary>
                                                                <AccordionDetails>
                                                                    <TableContainer
                                                                        component={
                                                                            Paper
                                                                        }
                                                                    >
                                                                        <Table
                                                                            sx={{
                                                                                minWidth: 650,
                                                                            }}
                                                                            aria-label="simple table"
                                                                        >
                                                                            <TableHead>
                                                                                <TableRow>
                                                                                    <TableCell></TableCell>
                                                                                    <TableCell>
                                                                                        Lavoratore
                                                                                    </TableCell>
                                                                                    <TableCell>
                                                                                        Presenza
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            </TableHead>
                                                                            {corso.Presenti.map(
                                                                                (
                                                                                    presente,
                                                                                    index
                                                                                ) => (
                                                                                    <TableRow
                                                                                        key={
                                                                                            index
                                                                                        }
                                                                                        sx={{
                                                                                            '&:last-child td, &:last-child th':
                                                                                                {
                                                                                                    border: 0,
                                                                                                },
                                                                                        }}
                                                                                    >
                                                                                        <TableCell
                                                                                            component="th"
                                                                                            scope="row"
                                                                                        >
                                                                                            <Circle
                                                                                                style={{
                                                                                                    color:
                                                                                                        presente.EraPresente ===
                                                                                                        0
                                                                                                            ? '#FF2768'
                                                                                                            : '#40C18F',
                                                                                                }}
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell
                                                                                            component="th"
                                                                                            scope="row"
                                                                                        >
                                                                                            {
                                                                                                presente.NomeLavoratore
                                                                                            }
                                                                                        </TableCell>
                                                                                        <TableCell>
                                                                                            {presente.EraPresente ===
                                                                                            0
                                                                                                ? 'NO'
                                                                                                : 'SI'}
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                )
                                                                            )}
                                                                        </Table>
                                                                    </TableContainer>
                                                                </AccordionDetails>
                                                            </Accordion>
                                                        )
                                                    )}
                                                </AccordionDetails>
                                            </Accordion>
                                        )
                                    )}

                                    {corsiDaFatturare.map((corso, index) => (
                                        <>
                                            <Table
                                                sx={{
                                                    minWidth: 650,
                                                    border: '1px solid black',
                                                    display: 'None',
                                                }}
                                                aria-label="simple table"
                                                id={'mytable' + index}
                                                size="small"
                                            >
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className="tableHeaderMiller">
                                                            {
                                                                corso.DescrizioneCorso
                                                            }{' '}
                                                        </TableCell>
                                                        <TableCell
                                                            className="tableHeaderMiller"
                                                            sx={{
                                                                textAlign:
                                                                    'right!important',
                                                            }}
                                                        >
                                                            {' '}
                                                            {'TOTALE ' +
                                                                corso.totaleTipoCorso +
                                                                ' €'}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                {corso.corsi.map(
                                                    (corsoNelDettaglio) => {
                                                        if (
                                                            corsoNelDettaglio.MostraInStampa !==
                                                            1
                                                        ) {
                                                            return null;
                                                        }

                                                        let head = '';

                                                        if (
                                                            corsoNelDettaglio.DataInizio ===
                                                            corsoNelDettaglio.DataFine
                                                        ) {
                                                            head =
                                                                'Data Corso : ' +
                                                                moment(
                                                                    corsoNelDettaglio.DataInizio
                                                                ).format(
                                                                    'DD/MM/YYYY'
                                                                );
                                                        } else {
                                                            head =
                                                                'Inizio : ' +
                                                                moment(
                                                                    corsoNelDettaglio.DataInizio
                                                                ).format(
                                                                    'DD/MM/YYYY'
                                                                ) +
                                                                ' Fine : ' +
                                                                moment(
                                                                    corsoNelDettaglio.DataFine
                                                                ).format(
                                                                    'DD/MM/YYYY'
                                                                );
                                                        }

                                                        return (
                                                            <>
                                                                <TableRow>
                                                                    <TableCell
                                                                        colspan={
                                                                            3
                                                                        }
                                                                        className="tableSubHeaderMiller"
                                                                    >
                                                                        {head +
                                                                            ' Durata : ' +
                                                                            corsoNelDettaglio.OreTotaliCorso +
                                                                            ' h - ' +
                                                                            (corsoNelDettaglio.DescrizioneFatturazione
                                                                                ? corsoNelDettaglio.DescrizioneFatturazione
                                                                                : 'Tariffa a Lavoratore') +
                                                                            ' - ' +
                                                                            corsoNelDettaglio.ModalitaDescrizione +
                                                                            (corsoNelDettaglio.Aggiornamento ===
                                                                            1
                                                                                ? ' - Aggiornamento'
                                                                                : '')}{' '}
                                                                    </TableCell>
                                                                </TableRow>

                                                                {corsoNelDettaglio.Presenti.map(
                                                                    (
                                                                        lavoratore
                                                                    ) => {
                                                                        if (
                                                                            lavoratore.EraPresente ===
                                                                                1 &&
                                                                            (!corsoNelDettaglio.DescrizioneFatturazione ||
                                                                                corsoNelDettaglio.DescrizioneFatturazione ===
                                                                                    'Tariffa a lavoratore')
                                                                        ) {
                                                                            return (
                                                                                <TableRow>
                                                                                    <TableCell className="tableTextMiller">
                                                                                        {
                                                                                            lavoratore.NomeLavoratore
                                                                                        }
                                                                                    </TableCell>
                                                                                    <TableCell className="tableTextMiller">
                                                                                        {corsoNelDettaglio.Tariffa +
                                                                                            ' €'}
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            );
                                                                        }
                                                                        if (
                                                                            lavoratore.EraPresente ===
                                                                                1 &&
                                                                            (corsoNelDettaglio.DescrizioneFatturazione ||
                                                                                corsoNelDettaglio.DescrizioneFatturazione ===
                                                                                    'Forfait')
                                                                        ) {
                                                                            return (
                                                                                <TableRow>
                                                                                    <TableCell
                                                                                        colspan={
                                                                                            3
                                                                                        }
                                                                                        className="tableTextMiller"
                                                                                    >
                                                                                        {
                                                                                            lavoratore.NomeLavoratore
                                                                                        }
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            );
                                                                        }

                                                                        return null;
                                                                    }
                                                                )}

                                                                <TableRow>
                                                                    <TableCell
                                                                        colspan={
                                                                            3
                                                                        }
                                                                        className="tableHeaderMiller"
                                                                        sx={{
                                                                            textAlign:
                                                                                'right!important',
                                                                        }}
                                                                    >
                                                                        <b>
                                                                            {(corsoNelDettaglio?.DescrizioneFatturazione ===
                                                                            'Forfait'
                                                                                ? 'IMPORTO FORFAIT ORARIO ' +
                                                                                  corsoNelDettaglio.CostoForfait +
                                                                                  ' € -'
                                                                                : '') +
                                                                                ' TOTALE CORSO ' +
                                                                                corsoNelDettaglio.totaleCorso +
                                                                                ' €'}{' '}
                                                                        </b>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </>
                                                        );
                                                    }
                                                )}
                                            </Table>
                                        </>
                                    ))}
                                </div>
                                <Table
                                    sx={{
                                        minWidth: 650,
                                        border: '1px solid black',
                                        display: 'none',
                                    }}
                                    aria-label="simple table"
                                    id={'footerTable'}
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                colspan={3}
                                                className="tableHeaderMiller"
                                                sx={{
                                                    textAlign:
                                                        'right!important',
                                                }}
                                            >
                                                {' TOTALE DA FATTURARE ' +
                                                    corsiDaFatturare.Totale +
                                                    ' €'}{' '}
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                </Table>
                            </Grid>
                        </Grid>
                    )}
                </TabPanel>
            </Box>
        </div>
    );
};

const FormDialog = (props) => {
    const [open, setOpen] = useState(false);
    const [corsoSel, setCorsoSel] = useState({
        Codice: 'Codice',
        Descrizione: 'Descrizione',
    });
    const [categoriaSel, setCategoriaSel] = useState({
        nome: 'Nome',
        codice: 'codice',
    });
    const [importi, setImporti] = useState({
        Importo: 0.0,
        ImportoAggiornamento: 0.0,
        ImportoEL: 0.0,
        ImportoAggiornamentoEL: 0.0,
        ScadenzaPersonalizzata: 0,
    });

    const handleClickOpen = () => {
        if (props.operazione === 'Inserimento') {
            setImporti({
                Importo: 0.0,
                ImportoAggiornamento: 0.0,
                ImportoEL: 0.0,
                ImportoAggiornamentoEL: 0.0,
                ScadenzaPersonalizzata: 0,
            });
        } else {
            setCorsoSel(props.corsoSel);
            const catCorso = props.categorie.filter(
                (c) => c.codice === props.corsoSel.CodiceCategoria
            )[0];
            setCategoriaSel(catCorso);
            setImporti({
                Importo: props.corsoSel.Importo,
                ImportoAggiornamento: props.corsoSel.ImportoAggiornamento,
                ImportoEL: props.corsoSel.ImportoEL,
                ImportoAggiornamentoEL: props.corsoSel.ImportoAggiornamentoEL,
                ScadenzaPersonalizzata: props.corsoSel.ScadenzaPersonalizzata,
            });
        }

        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = () => {
        props.saveFunction(corsoSel, importi, props.operazione, categoriaSel);
    };

    const handleChangeImporti = (e) => {
        let i = { ...importi };
        i[e.target.name] = e.target.value;
        setImporti(i);
    };
    return (
        <>
            <IconButton
                aria-label="edit"
                onClick={handleClickOpen}
                id={props.id}
                style={{ display: props.id === 'edit' ? '' : 'none' }}
            >
                <Edit
                    style={{
                        height: '2rem',
                        width: '2rem',
                        color: '#2265B1',
                    }}
                />
            </IconButton>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="sm"
                TransitionComponent={Transition}
            >
                <DialogTitle>Associa Corso</DialogTitle>
                <DialogContent sx={{ margin: '10px' }}>
                    <Grid container item xs={12} spacing={2}>
                        <Grid item xs={12}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={props.corsi}
                                value={corsoSel}
                                disabled={props.operazione === 'Modifica'}
                                getOptionLabel={(option) =>
                                    option.Codice + ' - ' + option.Descrizione
                                }
                                fullWidth
                                onChange={(event, newValue) => {
                                    setCorsoSel(newValue);

                                    //handleChangeCliente(newValue);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        label="Corso"
                                    />
                                )}
                                sx={{ mt: 1 }}
                            />
                        </Grid>
                        {corsoSel?.PeriodicitaAggiornamento === 1 ? (
                            <Grid item={true} xs={12}>
                                <TextField
                                    value={importi.ScadenzaPersonalizzata}
                                    margin="dense"
                                    name="ScadenzaPersonalizzata"
                                    label="Scadenza Personalizzata"
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                    onChange={handleChangeImporti}
                                />
                            </Grid>
                        ) : (
                            <></>
                        )}
                        <Grid item={true} xs={6}>
                            <TextField
                                value={importi.Importo}
                                margin="dense"
                                name="Importo"
                                label="Importo"
                                type="number"
                                fullWidth
                                variant="outlined"
                                onChange={handleChangeImporti}
                            />
                        </Grid>
                        <Grid item={true} xs={6}>
                            <TextField
                                value={importi.ImportoAggiornamento}
                                margin="dense"
                                name="ImportoAggiornamento"
                                label="Aggiornamento"
                                type="number"
                                fullWidth
                                variant="outlined"
                                onChange={handleChangeImporti}
                            />
                        </Grid>
                        <Grid item={true} xs={6}>
                            <TextField
                                value={importi.ImportoEL}
                                margin="dense"
                                name="ImportoEL"
                                label="Importo E-Learning"
                                type="number"
                                fullWidth
                                variant="outlined"
                                onChange={handleChangeImporti}
                            />
                        </Grid>
                        <Grid item={true} xs={6}>
                            <TextField
                                value={importi.ImportoAggiornamentoEL}
                                margin="dense"
                                name="ImportoAggiornamentoEL"
                                label="Aggiornamento E-Learning"
                                type="number"
                                fullWidth
                                onChange={handleChangeImporti}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                    {props.categorie.length > 0 && (
                        <Grid item={true} xs={12}>
                            <Autocomplete
                                id="categoria-box-demo"
                                options={props.categorie}
                                value={categoriaSel}
                                getOptionLabel={(option) =>
                                    `${option.nome} - ${option.codice}`
                                }
                                fullWidth
                                onChange={(event, newValue) => {
                                    setCategoriaSel(newValue);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        label="Categoria"
                                    />
                                )}
                                sx={{ mt: 1 }}
                            />
                        </Grid>
                    )}
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        pl: 4,
                        pr: 6,
                    }}
                >
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Close />}
                        onClick={handleClose}
                    >
                        Chiudi
                    </Button>
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Check />}
                        onClick={handleSave}
                    >
                        Salva
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const AssociationDialog = (props) => {
    const [open, setOpen] = useState(false);
    const [lavoratori, setLavoratori] = useState([]);
    const [associati, setAssociati] = useState([]);
    const [openBulkImport, setOpenBulkImport] = useState(false);

    const [allegati, setAllegati] = useState(undefined);
    const [lavoratore, setLavoratore] = useState(undefined);
    const [loadingAllegati, setLoadingAllegati] = useState(undefined);

    const columns = [
        {
            field: 'Cognome',
            headerName: 'Cognome',
            //width: 400,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Nome',
            headerName: 'Nome',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Qualifica',
            headerName: 'Qualifica',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Livello',
            headerName: 'Livello',
            //width: 400,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'TipoRapporto',
            headerName: 'Tipo Rapporto',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'TipoPartTime',
            headerName: 'Tipo Part Time',
            //width: 400,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'CentroDiCosto',
            headerName: 'CDC',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'DataAssunzione',
            headerName: 'Data Assunzione ',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (row) =>
                row.value ? moment(row.value).format('DD/MM/YYYY') : '',
        },
        {
            field: 'Attestati',
            headerName: 'Attestati',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (data) => (
                <>
                    {data.row.Associato === 1 && (
                        <Button
                            variant="contained"
                            className="ButtonMiller"
                            startIcon={
                                loadingAllegati === data.row.ID ? (
                                    <CircularProgress
                                        color="inherit"
                                        size={15}
                                    />
                                ) : (
                                    <Attachment color="inherit" />
                                )
                            }
                            onClick={async (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (loadingAllegati === data.row.ID) return;
                                loadAllegati(data.row.ID);
                                setLavoratore(data.row);
                            }}
                        >
                            Attestati
                        </Button>
                    )}
                </>
            ),
        },
    ];

    const handleClickOpen = async () => {
        await loadLavoratori();
        setOpen(true);
    };

    const loadAllegati = async (idLavoratore) => {
        setLoadingAllegati(idLavoratore);
        try {
            const res = await unsplash.get('/corsiLavoratore/allegati', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                params: {
                    cliente: props.idAzienda,
                    corso: props.corsoSel.Codice,
                    lavoratore: idLavoratore,
                },
            });

            setAllegati(res.data);
        } catch (e) {
            console.log(e);
        }

        setLoadingAllegati(undefined);
    };

    const loadLavoratori = async () => {
        try {
            const res = await unsplash.get('/corsiLavoratore/associati', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                params: {
                    cliente: props.idAzienda,
                    corso: props.corsoSel.Codice,
                },
            });

            setAssociati(
                res.data.data
                    .filter((el) => el.Associato === 1)
                    .map((el) => el.ID)
            );

            setLavoratori(res.data.data);
        } catch (e) {
            console.log(e);
        }
    };

    const handleSaveAssociati = async (e) => {
        try {
            let associati_inizio = lavoratori
                .filter((el) => el.Associato === 1)
                .map((el) => el.ID);
            let associati_da_aggiungere = associati.filter(
                (el) => associati_inizio.indexOf(el) === -1
            ); //non presenti all'inizio
            let associati_da_rimuovere = associati_inizio.filter(
                (el) => associati.indexOf(el) === -1
            ); //presenti all'inizio ma non più presenti attualmente

            await unsplash.post(
                '/corsiLavoratore/massivo',
                {
                    da_associare: associati_da_aggiungere,
                    da_rimuovere: associati_da_rimuovere,
                    corso: props.corsoSel.Codice,
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );

            await loadLavoratori();
            props.handleShowSnack(
                'Salvataggio avvenuto con successo',
                'success'
            );
        } catch (e) {
            console.log(e);
        }
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <GridToolbarQuickFilter placeholder="Cerca..." />
                </Grid>
            </GridToolbarContainer>
        );
    }

    return (
        <>
            <IconButton
                aria-label="edit"
                onClick={handleClickOpen}
                id={props.id}
                style={{ display: props.id === 'edit' ? '' : 'none' }}
            >
                <PersonAddAlt1
                    style={{
                        height: '2rem',
                        width: '2rem',
                        color: '#2265B1',
                    }}
                />
            </IconButton>
            <Dialog
                open={open}
                onClose={() => {
                    setOpen(false);
                }}
                maxWidth={'xl'}
                fullWidth={true}
                TransitionComponent={Transition}
            >
                <DialogTitle>Associa Partecipanti</DialogTitle>
                <DialogContent sx={{ margin: '10px' }}>
                    <Grid container item xs={12} spacing={2}>
                        <Grid item xs={12}>
                            <div style={{ height: 400, width: '100%' }}>
                                <DataGridPro
                                    localeText={
                                        itIT.components.MuiDataGrid.defaultProps
                                            .localeText
                                    }
                                    components={{
                                        Toolbar: CustomToolbar,
                                        Footer: CustomFooterPersonalized,
                                    }}
                                    rows={lavoratori}
                                    columns={columns}
                                    getRowId={(el) => el.ID}
                                    checkboxSelection
                                    selectionModel={associati}
                                    onSelectionModelChange={(e) => {
                                        setAssociati(e);
                                    }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        pl: 4,
                        pr: 6,
                    }}
                >
                    <Button
                        variant="contained"
                        className="ButtonMillerTextWhite"
                        startIcon={<Upload />}
                        onClick={() => {
                            setOpenBulkImport(true);
                        }}
                    >
                        Importa attestati
                    </Button>
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Close />}
                        onClick={() => {
                            setOpen(false);
                        }}
                    >
                        Chiudi
                    </Button>
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Check />}
                        onClick={handleSaveAssociati}
                    >
                        Salva
                    </Button>
                </DialogActions>
            </Dialog>
            <AllegatiDialog
                corso={props.corsoSel}
                lavoratore={lavoratore}
                allegati={allegati}
                onClose={() => {
                    setAllegati(undefined);
                }}
                onChange={() => {
                    loadAllegati(lavoratore.ID);
                }}
            />
            <BulkAttestatiImportDialog
                open={openBulkImport}
                clienteId={props.idAzienda}
                corsoSel={props.corsoSel}
                onClose={() => {
                    setOpenBulkImport(false);
                }}
                onImported={() => {
                    props.handleShowSnack(
                        'Import massivo attestati completato',
                        'success'
                    );
                }}
                handleShowSnack={props.handleShowSnack}
            />
        </>
    );
};

export const BulkAttestatiImportDialog = ({
    open,
    clienteId,
    corsoSel,
    onClose,
    onImported,
    handleShowSnack,
}) => {
    const [files, setFiles] = useState([]);
    const [analyzing, setAnalyzing] = useState(false);
    const [importing, setImporting] = useState(false);
    const [analysis, setAnalysis] = useState(null);
    const [rows, setRows] = useState([]);
    const [importReport, setImportReport] = useState(null);
    const [siglaOverride, setSiglaOverride] = useState('');
    const [preview, setPreview] = useState(null);
    useEffect(
        () => () => {
            if (preview?.url) URL.revokeObjectURL(preview.url);
        },
        [preview]
    );
    const fileInputRef = useRef(null);
    const pollingRef = useRef(null);

    const mergeRowsFromAnalysis = (payload, previousRows = []) => {
        const nextRowsById = new Map(
            previousRows.map((row) => [row.fileId, row])
        );

        (payload?.files || []).forEach((file) => {
            if (!nextRowsById.has(file.fileId)) {
                nextRowsById.set(file.fileId, {
                    fileId: file.fileId,
                    include:
                        !file.multiCfDetected &&
                        file.courseMismatch?.mismatchLevel !== 'strong',
                    workerId: file.selectedWorkerId || '',
                    courseId:
                        file.suggestedCourseIds?.length === 1
                            ? file.suggestedCourseIds[0]
                            : '',
                    date: file.dateCandidates?.[0] || '',
                });
            }
        });

        return Array.from(nextRowsById.values());
    };

    const resetDialogState = () => {
        if (pollingRef.current) {
            clearTimeout(pollingRef.current);
            pollingRef.current = null;
        }
        setFiles([]);
        setAnalysis(null);
        setRows([]);
        setAnalyzing(false);
        setImporting(false);
        setImportReport(null);
    };

    const cleanupAnalysisJob = async (jobId, silent = false) => {
        const resolvedJobId = String(jobId || '').trim();
        if (!resolvedJobId) return;

        try {
            await unsplash.post(
                '/attestatiMassivi/cleanup',
                { jobId: resolvedJobId },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );
        } catch (error) {
            if (!silent) {
                handleShowSnack?.(
                    error?.response?.data?.error ||
                        'Errore durante la pulizia dei file temporanei',
                    'error'
                );
            }
        }
    };

    const resetAnalysisSession = async (silent = false) => {
        const currentJobId = analysis?.jobId;
        if (currentJobId) {
            await cleanupAnalysisJob(currentJobId, silent);
        }
        resetDialogState();
    };

    useEffect(() => {
        if (!open) {
            resetDialogState();
            return;
        }
        setSiglaOverride(corsoSel?.Codice || '');
    }, [open, corsoSel?.Codice]);

    useEffect(() => {
        if (!open || !analysis?.jobId || analysis?.status !== 'processing') {
            if (pollingRef.current) {
                clearTimeout(pollingRef.current);
                pollingRef.current = null;
            }
            return;
        }

        const pollStatus = async () => {
            try {
                const response = await unsplash.get(
                    `/attestatiMassivi/status/${analysis.jobId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    }
                );

                const payload = response.data;
                setAnalysis(payload);
                setRows((current) => mergeRowsFromAnalysis(payload, current));

                if (payload.status === 'processing') {
                    pollingRef.current = setTimeout(pollStatus, 1500);
                    return;
                }

                pollingRef.current = null;
                setAnalyzing(false);

                if (payload.status === 'completed') {
                    handleShowSnack?.('Analisi completata', 'success');
                } else if (payload.status === 'failed') {
                    handleShowSnack?.(
                        payload.error || "Errore durante l'analisi dei PDF",
                        'error'
                    );
                }
            } catch (error) {
                pollingRef.current = null;
                setAnalyzing(false);
                handleShowSnack?.(
                    error?.response?.data?.error ||
                        "Errore durante l'aggiornamento dello stato di analisi",
                    'error'
                );
            }
        };

        pollingRef.current = setTimeout(pollStatus, 1000);

        return () => {
            if (pollingRef.current) {
                clearTimeout(pollingRef.current);
                pollingRef.current = null;
            }
        };
    }, [open, analysis?.jobId, analysis?.status, handleShowSnack]);

    const handleAnalyze = async () => {
        if (!files.length) {
            fileInputRef.current?.click();
            return;
        }

        setAnalyzing(true);
        try {
            const formData = new FormData();
            files.forEach((file) => {
                formData.append('file', file);
            });
            formData.append('clienteId', clienteId);
            formData.append('corsoCodice', corsoSel.Codice);

            const response = await unsplash.post(
                '/attestatiMassivi/analyze',
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            const payload = response.data;
            setAnalysis(payload);
            setImportReport(null);
            setRows(mergeRowsFromAnalysis(payload, []));
            if (payload.status !== 'processing') {
                setAnalyzing(false);
            }
        } catch (error) {
            setAnalyzing(false);
            handleShowSnack?.(
                error?.response?.data?.error ||
                    "Errore durante l'analisi dei PDF",
                'error'
            );
        }
    };

    const updateRow = (fileId, patch) => {
        setRows((current) =>
            current.map((row) =>
                row.fileId === fileId ? { ...row, ...patch } : row
            )
        );
    };

    const openPreview = async (file) => {
        try {
            const response = await unsplash.get(
                `/attestatiMassivi/preview/${analysis.jobId}/${file.fileId}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                    responseType: 'blob',
                }
            );
            setPreview({
                name: file.originalName,
                url: URL.createObjectURL(response.data),
            });
        } catch (_error) {
            handleShowSnack?.('Impossibile aprire l’anteprima', 'error');
        }
    };

    const getRowState = (fileId) =>
        rows.find((row) => row.fileId === fileId) || {};

    const getCourseOptionsForFile = (file, row) => {
        const resolvedWorkerId = Number(
            row?.workerId || file?.selectedWorkerId || 0
        );
        if (!resolvedWorkerId) {
            return [];
        }

        const suggestedIds = new Set(file.suggestedCourseIds || []);
        return (analysis?.courseOptions || []).filter((course) => {
            const workerIds = new Set(course.workerIds || []);
            if (workerIds.size && !workerIds.has(resolvedWorkerId)) {
                return false;
            }
            return !suggestedIds.size || suggestedIds.has(course.id);
        });
    };

    const getWorkerOptionsForFile = (file) => {
        const compatibleIds = new Set(file.compatibleWorkerIds || []);
        return (analysis?.workers || []).filter((worker) =>
            compatibleIds.has(worker.id)
        );
    };

    const includedRows = rows.filter(
        (row) => row.include !== false && !row.mergePrevious
    );
    const includedFileIdsWithErrors = new Set(
        (analysis?.files || [])
            .filter(
                (file) =>
                    (file.anomalies || []).length > 0 &&
                    includedRows.some((row) => row.fileId === file.fileId)
            )
            .map((file) => file.fileId)
    );
    const hasImportableRows = includedRows.some(
        (row) => !includedFileIdsWithErrors.has(row.fileId)
    );
    const hasInvalidSelectionsOnImportableRows = includedRows.some((row) => {
        if (includedFileIdsWithErrors.has(row.fileId)) return false;
        return !row.workerId || !row.courseId;
    });

    const handleImport = async () => {
        if (!analysis?.jobId) {
            handleShowSnack?.("Esegui prima l'analisi", 'error');
            return;
        }
        if (analysis?.status === 'processing') {
            return;
        }
        if (!hasImportableRows) {
            handleShowSnack?.(
                'Non ci sono attestati importabili nella selezione corrente',
                'error'
            );
            return;
        }
        if (hasInvalidSelectionsOnImportableRows) {
            handleShowSnack?.(
                'Completa lavoratore e corso per tutti i file importabili inclusi',
                'error'
            );
            return;
        }

        setImporting(true);
        try {
            const response = await unsplash.post(
                '/attestatiMassivi/import',
                {
                    jobId: analysis.jobId,
                    decisions: rows,
                    siglaOverride,
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );

            if (response.data?.processing) {
                return;
            }

            const importedCount = response.data?.importedCount ?? 0;
            const skippedCount = response.data?.skippedCount ?? 0;
            const skipped = response.data?.skipped || [];
            setImportReport({
                importedCount,
                skippedCount,
                skipped,
            });
            const message =
                skippedCount > 0
                    ? `Importati ${importedCount} attestati, saltati ${skippedCount}`
                    : `Importati ${importedCount} attestati`;
            handleShowSnack?.(
                message,
                skippedCount > 0 ? 'warning' : 'success'
            );
            if (importedCount > 0 && skippedCount === 0) {
                onImported?.();
            }
            if (skippedCount === 0) {
                onClose?.();
            }
        } catch (error) {
            handleShowSnack?.(
                error?.response?.data?.error ||
                    "Errore durante l'import massivo",
                'error'
            );
        } finally {
            setImporting(false);
        }
    };

    const handleCancelAnalysis = async () => {
        if (analysis?.status !== 'processing') {
            return;
        }
        await resetAnalysisSession(true);
    };

    const handleDialogClose = async () => {
        if (importing) {
            return;
        }
        await resetAnalysisSession(true);
        onClose?.();
    };

    const handleFilesChange = async (selectedFiles) => {
        if (analysis?.jobId) {
            await resetAnalysisSession(true);
        }
        setFiles(selectedFiles);
    };

    return (
        <Dialog open={open} onClose={handleDialogClose} maxWidth="xl" fullWidth>
            <DialogTitle>
                Import massivo attestati - {corsoSel?.Descrizione}
            </DialogTitle>
            <Dialog
                open={!!preview}
                onClose={() => setPreview(null)}
                fullWidth
                maxWidth="lg"
            >
                <DialogTitle>{preview?.name}</DialogTitle>
                <DialogContent>
                    <iframe
                        title="Anteprima attestato"
                        src={preview?.url}
                        style={{ width: '100%', height: '75vh', border: 0 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setPreview(null)}>Chiudi</Button>
                </DialogActions>
            </Dialog>
            <DialogContent sx={{ margin: '10px' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={8}>
                        <Button
                            variant="contained"
                            component="label"
                            className="ButtonMillerTextWhite"
                            sx={{
                                color: '#fff',
                                '& .MuiButton-startIcon': {
                                    color: '#fff',
                                },
                                '&.Mui-disabled': {
                                    color: '#fff',
                                },
                            }}
                            startIcon={<Upload />}
                        >
                            Seleziona PDF
                            <input
                                ref={fileInputRef}
                                hidden
                                multiple
                                accept="application/pdf"
                                type="file"
                                onChange={async (e) => {
                                    await handleFilesChange(
                                        Array.from(e.target.files || [])
                                    );
                                }}
                            />
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Button
                            variant="contained"
                            className="ButtonMillerTextWhite"
                            fullWidth
                            disabled={analyzing || importing}
                            sx={{
                                color: '#fff',
                                '& .MuiButton-startIcon': {
                                    color: '#fff',
                                },
                                '&.Mui-disabled': {
                                    color: '#fff',
                                },
                            }}
                            startIcon={
                                analyzing ? (
                                    <CircularProgress
                                        color="inherit"
                                        size={15}
                                    />
                                ) : (
                                    <Search />
                                )
                            }
                            onClick={handleAnalyze}
                        >
                            {analysis?.status === 'processing'
                                ? 'Analisi in corso...'
                                : 'Analizza file'}
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body2">
                            File selezionati:{' '}
                            {files.length
                                ? files.map((file) => file.name).join(', ')
                                : 'nessuno'}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            size="small"
                            label="Sigla nel nome file"
                            value={siglaOverride}
                            onChange={(e) =>
                                setSiglaOverride(
                                    e.target.value.replace(/\s+/g, '_')
                                )
                            }
                            disabled={importing}
                            helperText={`Verrà salvato come: attestato_${siglaOverride || corsoSel?.Codice || ''}_<CF>_<DATA>.pdf`}
                        />
                    </Grid>
                    {importReport && importReport.skippedCount > 0 && (
                        <Grid item xs={12}>
                            <Paper
                                variant="outlined"
                                sx={{
                                    p: 2,
                                    borderColor: '#ed6c02',
                                    backgroundColor: '#fff8f1',
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{ fontWeight: 600, mb: 1 }}
                                >
                                    Attestati non importati:{' '}
                                    {importReport.skippedCount}
                                </Typography>
                                {importReport.skipped.map((reason, index) => (
                                    <Typography
                                        key={`${reason}_${index}`}
                                        variant="body2"
                                        sx={{
                                            mb:
                                                index ===
                                                importReport.skipped.length - 1
                                                    ? 0
                                                    : 0.5,
                                        }}
                                    >
                                        {reason}
                                    </Typography>
                                ))}
                            </Paper>
                        </Grid>
                    )}
                    {analysis?.status === 'processing' && (
                        <Grid item xs={12}>
                            <Paper
                                variant="outlined"
                                sx={{
                                    p: 2,
                                    borderColor: '#1976d2',
                                    backgroundColor: '#f4f8ff',
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{ fontWeight: 600, mb: 1 }}
                                >
                                    Analisi in corso
                                </Typography>
                                <LinearProgress
                                    variant="determinate"
                                    value={
                                        (analysis?.progress?.totalPages || 0) >
                                        0
                                            ? Math.min(
                                                  100,
                                                  Math.round(
                                                      ((analysis?.progress
                                                          ?.processedPages ||
                                                          0) /
                                                          (analysis?.progress
                                                              ?.totalPages ||
                                                              1)) *
                                                          100
                                                  )
                                              )
                                            : 0
                                    }
                                    sx={{
                                        mb: 1.5,
                                        height: 8,
                                        borderRadius: 999,
                                        backgroundColor: '#dbe8fb',
                                    }}
                                />
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={4}>
                                        <Typography variant="body2">
                                            File:{' '}
                                            <strong>
                                                {analysis?.progress
                                                    ?.processedSourceFiles || 0}
                                                /
                                                {analysis?.progress
                                                    ?.totalSourceFiles || 0}
                                            </strong>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Typography variant="body2">
                                            Pagine:{' '}
                                            <strong>
                                                {analysis?.progress
                                                    ?.processedPages || 0}
                                                /
                                                {analysis?.progress
                                                    ?.totalPages || 0}
                                            </strong>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Typography variant="body2">
                                            Attestati trovati:{' '}
                                            <strong>
                                                {analysis?.files?.length || 0}
                                            </strong>
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    )}
                    {analysis && (
                        <Grid item xs={12}>
                            <TableContainer component={Paper}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Importa</TableCell>
                                            <TableCell>
                                                File / anteprima
                                            </TableCell>
                                            <TableCell>
                                                Possibile continuazione
                                            </TableCell>
                                            <TableCell>CF rilevati</TableCell>
                                            <TableCell>Date rilevate</TableCell>
                                            <TableCell>Lavoratore</TableCell>
                                            <TableCell>Edizione</TableCell>
                                            <TableCell>Note</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {(analysis.files || []).map(
                                            (file, index) => {
                                                const previous =
                                                    analysis.files[index - 1];
                                                let rootIndex = index - 1;
                                                while (
                                                    rootIndex > 0 &&
                                                    getRowState(
                                                        analysis.files[
                                                            rootIndex
                                                        ].fileId
                                                    ).mergePrevious
                                                )
                                                    rootIndex--;
                                                const root =
                                                    analysis.files[rootIndex];
                                                const rootRow =
                                                    root &&
                                                    getRowState(root.fileId);
                                                const canMerge =
                                                    previous &&
                                                    root &&
                                                    rootRow?.include !==
                                                        false &&
                                                    !root.anomalies?.length &&
                                                    root.cfCandidates?.length &&
                                                    file.sourceId &&
                                                    file.sourceId ===
                                                        previous.sourceId &&
                                                    file.pageNumber ===
                                                        previous.pageNumber +
                                                            (previous.pageSpan ||
                                                                1) &&
                                                    !(file.cfCandidates || [])
                                                        .length &&
                                                    (
                                                        file.anomalies || []
                                                    ).includes(
                                                        'Codice fiscale non rilevato'
                                                    ) &&
                                                    (
                                                        file.anomalies || []
                                                    ).every((a) =>
                                                        [
                                                            'Codice fiscale non rilevato',
                                                            'Data corso non rilevata',
                                                        ].includes(a)
                                                    );
                                                const row = getRowState(
                                                    file.fileId
                                                );
                                                return (
                                                    <TableRow key={file.fileId}>
                                                        <TableCell>
                                                            <input
                                                                type="checkbox"
                                                                disabled={
                                                                    !!row.mergePrevious ||
                                                                    !!rows.find(
                                                                        (
                                                                            item
                                                                        ) =>
                                                                            item.mergePrevious &&
                                                                            analysis.files.findIndex(
                                                                                (
                                                                                    candidate
                                                                                ) =>
                                                                                    candidate.fileId ===
                                                                                    item.fileId
                                                                            ) ===
                                                                                index +
                                                                                    1
                                                                    )
                                                                }
                                                                checked={
                                                                    row.include !==
                                                                    false
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    updateRow(
                                                                        file.fileId,
                                                                        {
                                                                            include:
                                                                                e
                                                                                    .target
                                                                                    .checked,
                                                                        }
                                                                    );
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            {file.originalName}
                                                            <IconButton
                                                                size="small"
                                                                aria-label={`Anteprima ${file.originalName}`}
                                                                onClick={() =>
                                                                    openPreview(
                                                                        file
                                                                    )
                                                                }
                                                            >
                                                                <Visibility />
                                                            </IconButton>
                                                        </TableCell>
                                                        <TableCell>
                                                            {canMerge && (
                                                                <label>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={
                                                                            !!row.mergePrevious
                                                                        }
                                                                        disabled={
                                                                            analysis.status ===
                                                                            'processing'
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            updateRow(
                                                                                file.fileId,
                                                                                {
                                                                                    mergePrevious:
                                                                                        e
                                                                                            .target
                                                                                            .checked,
                                                                                    include:
                                                                                        e
                                                                                            .target
                                                                                            .checked
                                                                                            ? true
                                                                                            : row.include,
                                                                                }
                                                                            )
                                                                        }
                                                                    />{' '}
                                                                    Unisci alla
                                                                    precedente
                                                                </label>
                                                            )}
                                                        </TableCell>
                                                        <TableCell>
                                                            {file.cfCandidates
                                                                ?.length
                                                                ? file.cfCandidates.join(
                                                                      ', '
                                                                  )
                                                                : '-'}
                                                        </TableCell>
                                                        <TableCell>
                                                            {file.dateCandidates
                                                                ?.length
                                                                ? file.dateCandidates
                                                                      .map(
                                                                          (
                                                                              date
                                                                          ) =>
                                                                              moment(
                                                                                  date
                                                                              ).format(
                                                                                  'DD/MM/YYYY'
                                                                              )
                                                                      )
                                                                      .join(
                                                                          ', '
                                                                      )
                                                                : '-'}
                                                        </TableCell>
                                                        <TableCell
                                                            sx={{
                                                                minWidth: 240,
                                                            }}
                                                        >
                                                            <TextField
                                                                select
                                                                fullWidth
                                                                disabled={
                                                                    !!row.mergePrevious
                                                                }
                                                                size="small"
                                                                value={
                                                                    row.workerId ||
                                                                    ''
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    updateRow(
                                                                        file.fileId,
                                                                        {
                                                                            workerId:
                                                                                e
                                                                                    .target
                                                                                    .value,
                                                                        }
                                                                    );
                                                                }}
                                                            >
                                                                <MenuItem value="">
                                                                    Seleziona
                                                                </MenuItem>
                                                                {getWorkerOptionsForFile(
                                                                    file
                                                                ).map(
                                                                    (
                                                                        worker
                                                                    ) => (
                                                                        <MenuItem
                                                                            key={
                                                                                worker.id
                                                                            }
                                                                            value={
                                                                                worker.id
                                                                            }
                                                                        >
                                                                            {
                                                                                worker.label
                                                                            }{' '}
                                                                            -{' '}
                                                                            {
                                                                                worker.cf
                                                                            }
                                                                        </MenuItem>
                                                                    )
                                                                )}
                                                            </TextField>
                                                        </TableCell>
                                                        <TableCell
                                                            sx={{
                                                                minWidth: 260,
                                                            }}
                                                        >
                                                            <TextField
                                                                select
                                                                fullWidth
                                                                disabled={
                                                                    !!row.mergePrevious
                                                                }
                                                                size="small"
                                                                value={
                                                                    row.courseId ||
                                                                    ''
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    updateRow(
                                                                        file.fileId,
                                                                        {
                                                                            courseId:
                                                                                e
                                                                                    .target
                                                                                    .value,
                                                                        }
                                                                    );
                                                                }}
                                                            >
                                                                <MenuItem value="">
                                                                    Seleziona
                                                                </MenuItem>
                                                                {getCourseOptionsForFile(
                                                                    file,
                                                                    row
                                                                ).map(
                                                                    (
                                                                        course
                                                                    ) => (
                                                                        <MenuItem
                                                                            key={
                                                                                course.id
                                                                            }
                                                                            value={
                                                                                course.id
                                                                            }
                                                                        >
                                                                            {
                                                                                course.label
                                                                            }
                                                                        </MenuItem>
                                                                    )
                                                                )}
                                                            </TextField>
                                                        </TableCell>
                                                        <TableCell>
                                                            {row.mergePrevious
                                                                ? 'Sarà unita alla pagina precedente'
                                                                : file.anomalies
                                                                        ?.length
                                                                  ? file.anomalies.join(
                                                                        ' | '
                                                                    )
                                                                  : file
                                                                          .courseMismatch
                                                                          ?.mismatchLevel ===
                                                                      'none'
                                                                    ? 'OK'
                                                                    : 'Da verificare'}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            }
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    pl: 4,
                    pr: 6,
                }}
            >
                <Button
                    variant="contained"
                    className="ButtonMillerTextWhite"
                    startIcon={<Close />}
                    sx={{
                        color: '#fff',
                        '& .MuiButton-startIcon': {
                            color: '#fff',
                        },
                        '&.Mui-disabled': {
                            color: '#fff',
                        },
                    }}
                    onClick={handleDialogClose}
                >
                    Chiudi
                </Button>
                <Button
                    variant="contained"
                    className="ButtonMillerTextWhite"
                    startIcon={
                        importing ? (
                            <CircularProgress color="inherit" size={15} />
                        ) : (
                            <Check />
                        )
                    }
                    disabled={
                        !analysis ||
                        importing ||
                        (analyzing && analysis?.status !== 'processing') ||
                        (analysis?.status !== 'processing' &&
                            (!hasImportableRows ||
                                hasInvalidSelectionsOnImportableRows))
                    }
                    sx={{
                        color: '#fff',
                        '& .MuiButton-startIcon': {
                            color: '#fff',
                        },
                        '&.Mui-disabled, &.MuiButtonBase-root.Mui-disabled': {
                            color: '#fff !important',
                            backgroundColor: '#9e9e9e !important',
                            opacity: 1,
                            boxShadow: 'none',
                        },
                    }}
                    onClick={
                        analysis?.status === 'processing'
                            ? handleCancelAnalysis
                            : handleImport
                    }
                >
                    {analysis?.status === 'processing'
                        ? 'Annulla'
                        : 'Conferma import'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const AllegatiDialog = ({
    allegati,
    corso,
    lavoratore,
    onClose,
    onChange,
    ...props
}) => {
    const [uploading, setUploading] = useState(undefined);
    const [deleting, setDeleting] = useState(undefined);

    const columns = [
        {
            field: 'tipo',
            headerName: 'Codice',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'nome',
            headerName: 'Descrizione',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'data',
            headerName: 'Data',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (data) => moment(data.row.data).format('DD/MM/YYYY'),
        },
        {
            field: 'modalita',
            headerName: 'Modalità',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'Attestato',
            headerName: 'Attestato',
            //width: 300,
            flex: 2,
            headerAlign: 'center',
            align: 'center',
            renderCell: (data) => (
                <>
                    {data.row.allegati?.length === 0 && (
                        <>
                            <Button
                                variant="contained"
                                className="ButtonMiller"
                                startIcon={
                                    uploading === data.row.id ? (
                                        <CircularProgress
                                            color="inherit"
                                            size={15}
                                        />
                                    ) : (
                                        <Upload color="inherit" />
                                    )
                                }
                                onClick={async (e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (uploading === data.row.id) return;
                                    document
                                        .getElementById(
                                            `file-input-${data.row.id}`
                                        )
                                        .click();
                                }}
                            >
                                Carica
                            </Button>
                            <input
                                type="file"
                                style={{ display: 'none' }}
                                id={`file-input-${data.row.id}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                                onChange={async (e) => {
                                    if (e.target.files.length === 0) return;
                                    setUploading(data.row.id);

                                    const formData = new FormData();
                                    formData.append('file', e.target.files[0]);
                                    formData.append('corso', data.row.id);
                                    formData.append(
                                        'lavoratore',
                                        lavoratore.ID
                                    );
                                    formData.append(
                                        'filename',
                                        e.target.files[0].name
                                    );
                                    formData.append(
                                        'filesize',
                                        e.target.files[0].size
                                    );
                                    formData.append(
                                        'filetype',
                                        e.target.files[0].type
                                    );

                                    try {
                                        await unsplash.post(
                                            '/corsiLavoratore/allegati',
                                            formData,
                                            {
                                                headers: {
                                                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                                                    'Content-Type':
                                                        'multipart/form-data',
                                                },
                                            }
                                        );

                                        document.getElementById(
                                            `file-input-${data.row.id}`
                                        ).value = null;
                                    } catch (e) {
                                        console.log(e);
                                    }

                                    await onChange?.();
                                    setUploading(undefined);
                                }}
                            />
                        </>
                    )}
                    {data.row.allegati?.length > 0 && (
                        <>
                            <Button
                                variant="contained"
                                className="ButtonMiller"
                                startIcon={<Attachment color="inherit" />}
                                onClick={async (e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    downloadFile(
                                        data.row.allegati[0].ID,
                                        data.row.allegati[0].Estensione,
                                        data.row.allegati[0].Descrizione,
                                        'visualizza'
                                    );
                                }}
                            >
                                Visualizza
                            </Button>
                            <Button
                                variant="contained"
                                className="ButtonMiller"
                                startIcon={
                                    deleting === data.row.id ? (
                                        <CircularProgress
                                            color="inherit"
                                            size={15}
                                        />
                                    ) : (
                                        <Delete color="inherit" />
                                    )
                                }
                                style={{ marginLeft: '10px' }}
                                onClick={async (e) => {
                                    e.preventDefault();
                                    e.stopPropagation();

                                    if (deleting === data.row.id) return;
                                    setDeleting(data.row.id);

                                    try {
                                        await unsplash.delete(
                                            '/corsiLavoratore/allegati',
                                            {
                                                headers: {
                                                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                                                    'Content-Type':
                                                        'multipart/form-data',
                                                },
                                                data: {
                                                    id: data.row.allegati[0].ID,
                                                },
                                            }
                                        );
                                    } catch (e) {
                                        console.log(e);
                                    }

                                    await onChange?.();
                                    setDeleting(undefined);
                                }}
                            >
                                Elimina
                            </Button>
                        </>
                    )}
                </>
            ),
        },
    ];

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <GridToolbarQuickFilter placeholder="Cerca..." />
                </Grid>
            </GridToolbarContainer>
        );
    }

    return (
        <>
            <Dialog
                open={!!allegati}
                onClose={props.onClose}
                maxWidth={'xl'}
                fullWidth={true}
            >
                <DialogTitle>
                    Attestati - {corso.Descrizione} -{' '}
                    {`${lavoratore?.Nome ?? ''} ${lavoratore?.Cognome ?? ''}`.trim()}
                </DialogTitle>
                <DialogContent sx={{ margin: '10px' }}>
                    <Grid container item xs={12} spacing={2}>
                        <Grid item xs={12}>
                            <div style={{ height: 400, width: '100%' }}>
                                <DataGridPro
                                    localeText={
                                        itIT.components.MuiDataGrid.defaultProps
                                            .localeText
                                    }
                                    components={{
                                        Toolbar: CustomToolbar,
                                        Footer: CustomFooterPersonalized,
                                    }}
                                    rows={allegati ?? []}
                                    columns={columns}
                                    getRowId={(el) => el.id}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        pl: 4,
                        pr: 6,
                    }}
                >
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Close />}
                        onClick={onClose}
                    >
                        Chiudi
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default CorsiCliente;

const DeleteCorsi = (props) => {
    const [openSnackDel, setOpenSnackDel] = useState(false);
    const [snackDel, setSnackDel] = useState({
        severity: 'success',
        messaggio: 'Eliminazione effettuata correttamente',
        open: false,
    });
    const handleCloseSnackDel = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackDel(false);
    };
    const handleDelete = async () => {
        try {
            await unsplash.delete('corsiCliente', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                data: { id: props.corso.ID },
            });
            setSnackDel({
                severity: 'success',
                messaggio: 'Eliminazione effettuata correttamente',
            });
            setOpenSnackDel(true);
        } catch {
            setSnackDel({
                severity: 'error',
                messaggio: "Errore durante l'eliminazione",
            });
            setOpenSnackDel(true);
        }
        props.openFunction(true);
    };
    return (
        <>
            <GlobalSnackbar
                severity={snackDel.severity}
                messaggio={snackDel.messaggio}
                openSnack={openSnackDel}
                handleCloseSnack={handleCloseSnackDel}
            />
            <Dialog
                open={props.openValue}
                onClose={props.openFunction}
                maxWidth="md"
                TransitionComponent={Transition}
            >
                {props.corso ? (
                    <DialogTitle>
                        Sei sicuro di voler eliminare {props.corso.Descrizione}?
                    </DialogTitle>
                ) : (
                    <DialogTitle>Sei sicuro di voler eliminare?</DialogTitle>
                )}
                <DialogContent
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                >
                    <Button onClick={props.openFunction}>ANNULLA</Button>
                    <Button onClick={handleDelete}>ELIMINA</Button>
                </DialogContent>
            </Dialog>
        </>
    );
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: index === 0 ? 0 : 3 }}>
                    <Box>{children}</Box>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const downloadFile = async (id, estensione, descrizione, operazione) => {
    const ext = {
        doc: 'application/msword',
        dot: 'application/msword',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        dotx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        docm: 'application/vnd.ms-word.document.macroEnabled.12',
        dotm: 'application/vnd.ms-word.template.macroEnabled.12',
        xls: 'application/vnd.ms-excel',
        xlt: 'application/vnd.ms-excel',
        xla: 'application/vnd.ms-excel',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        xltx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        xlsm: 'application/vnd.ms-excel.sheet.macroEnabled.12',
        xltm: 'application/vnd.ms-excel.template.macroEnabled.12',
        xlam: 'application/vnd.ms-excel.addin.macroEnabled.12',
        xlsb: 'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
        ppt: 'application/vnd.ms-powerpoint',
        pot: 'application/vnd.ms-powerpoint',
        pps: 'application/vnd.ms-powerpoint',
        ppa: 'application/vnd.ms-powerpoint',
        pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        potx: 'application/vnd.openxmlformats-officedocument.presentationml.template',
        ppsx: 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        ppam: 'application/vnd.ms-powerpoint.addin.macroEnabled.12',
        pptm: 'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
        potm: 'application/vnd.ms-powerpoint.template.macroEnabled.12',
        ppsm: 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
        mdb: 'application/vnd.ms-access',
        png: 'application/png',
        pdf: 'application/pdf',
    };

    try {
        const response = await unsplash.post(
            'ftp',
            {
                file: id + estensione,
                nomeOriginale: descrizione.includes(estensione)
                    ? descrizione
                    : descrizione + estensione,
                operazione: 'download',
            },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                responseType: 'blob',
            }
        );
        const url = window.URL.createObjectURL(
            new Blob([response.data], {
                type: ext[estensione.replace('.', '')],
            })
        );
        const link = document.createElement('a');
        link.href = url;
        if (operazione === 'download') {
            link.setAttribute(
                'download',
                descrizione.includes(estensione)
                    ? descrizione
                    : descrizione + estensione
            );
            document.body.appendChild(link);
            link.click();
        }

        if (operazione === 'visualizza') {
            if (estensione === '.pdf') {
                window.open(url);
            }
        }
    } catch {
        // void
    }
};
